import React from 'react';
import './privacy-policy.css';

const PrivacyPolicy = () => {
  return (
    <div className="privacy-policy-container">
      <header className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>E-Techno Educational and Research Society</p>
      </header>

      <section className="privacy-section">
        <h2>1. Information We Collect</h2>
        <p>
          E-Techno Educational and Research Society collects personal details such as name, email, phone number, and address when you interact with us, participate in our programs, or make donations.
        </p>
      </section>

      <section className="privacy-section">
        <h2>2. How We Use Your Information</h2>
        <ul>
          <li>Provide educational, vocational, health, social welfare, and cultural services.</li>
          <li>Communicate updates, events, and developments in our programs.</li>
          <li>Manage donations, sponsorships, and financial records.</li>
          <li>Conduct research, workshops, and seminars for community development.</li>
          <li>Improve our website and services.</li>
        </ul>
      </section>

      <section className="privacy-section">
        <h2>3. Information Sharing</h2>
        <p>
          We do not sell or trade your data. Information is shared only with trusted service providers or as required by law, such as government bodies, regulatory authorities, or service providers assisting in operational activities.
        </p>
      </section>

      <section className="privacy-section">
        <h2>4. Data Security</h2>
        <p>
          We implement appropriate technical and organizational security measures to protect your information from unauthorized access, alteration, or destruction. However, no method of electronic transmission or storage is completely secure.
        </p>
      </section>

      <section className="privacy-section">
        <h2>5. Your Rights</h2>
        <p>
          You can request access, correction, or deletion of your personal data by contacting us at <strong>contact@etechnoedu.org</strong>.
        </p>
      </section>

      <section className="privacy-section">
        <h2>6. Data Retention</h2>
        <p>
          We retain personal information as long as necessary to fulfill the purposes outlined in this policy, in accordance with applicable legal requirements.
        </p>
      </section>

      <section className="privacy-section">
        <h2>7. Cookies and Website Usage</h2>
        <p>
          We use cookies to enhance your user experience. By using our website, you agree to our use of cookies. You may disable cookies through your browser settings.
        </p>
      </section>

      <section className="privacy-section">
        <h2>8. Changes to this Privacy Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Please review it whenever you visit our website.
        </p>
      </section>

      <section className="privacy-section">
        <h2>9. Contact Us</h2>
        <p>
          For questions or concerns, contact: <br />
          <strong>E-Techno Educational and Research Society</strong> <br />
          Email: <a href="mailto:contact@etechnoedu.org">contact@etechnoedu.org</a>
        </p>
      </section>

      <footer className="privacy-footer">
        <p>&copy; 2024 E-Techno Educational and Research Society. All rights reserved.</p>
      </footer>
    </div>
  );
};

export default PrivacyPolicy;
